// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ta-9","textarea":"styles_textarea__2MA75"};